export const SIDE_NAV_WIDTH = 85;
export const RIGHT_PANEL_MIN_WIDTH = 400;
export const RIGHT_PANEL_MAX_WIDTH = 800;
